import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Buttons from "../Buttons/Buttons";

// Single-button info/error popup. One of the two focused replacements for
// ReusableModal (the other is ConfirmDialog), both built on MUI Dialog so
// focus trapping/Escape/backdrop-close come for free instead of being
// hand-rolled per popup.
const ErrorAlert = ({ open, onClose, content, buttonText, onButtonClick }) => {
  const handleClick = () => {
    onClose();
    if (onButtonClick) {
      onButtonClick();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth aria-labelledby="error-alert-title">
      <DialogContent>
        <DialogContentText id="error-alert-title" sx={{ color: "text.primary" }}>
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Buttons onClick={handleClick} variant="smallprimary" text={buttonText} />
      </DialogActions>
    </Dialog>
  );
};

export default ErrorAlert;
